import { ThemeToggle } from './ThemeToggle';
import type { Theme } from '../hooks/useTheme';

const NAV_LINKS = [
  { href: '#problem', label: 'The problem' },
  { href: '#how', label: 'How it works' },
  { href: '#why', label: 'Why Northforge' },
];

interface HeaderProps {
  theme: Theme;
  onToggleTheme: () => void;
}

export function Header({ theme, onToggleTheme }: HeaderProps) {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[var(--line)] bg-[var(--navbg)] backdrop-blur-[14px] transition-colors duration-[450ms]">
      <nav className="mx-auto flex max-w-[1200px] items-center justify-between gap-4 px-6 py-3.5">
        <a href="#top" className="flex items-center gap-3 text-ink">
          <span className="relative block h-[38px] w-[38px] flex-none">
            <img
              src="/images/NFS_Logo_0.1_light.png"
              alt="Northforge Solutions"
              className="absolute inset-0 h-full w-full object-contain transition-opacity duration-[450ms]"
              style={{ opacity: 'var(--logo-light)' }}
            />
            <img
              src="/images/NFS_Logo_0.1.png"
              alt=""
              aria-hidden="true"
              className="absolute inset-0 h-full w-full object-contain transition-opacity duration-[450ms]"
              style={{ opacity: 'var(--logo-dark)' }}
            />
          </span>
          <span className="flex flex-col leading-[1.05]">
            <span className="font-display text-[15px] font-semibold tracking-[0.02em]">
              NORTHFORGE
            </span>
            <span className="text-[10px] tracking-[0.34em] text-dim">SOLUTIONS</span>
          </span>
        </a>

        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-1 min-[900px]:flex">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-lg px-3 py-2 text-sm text-dim transition-colors hover:bg-[var(--card)] hover:text-ink"
              >
                {link.label}
              </a>
            ))}
          </div>

          <ThemeToggle theme={theme} onToggle={onToggleTheme} />

          <a
            href="#contact"
            className="hidden rounded-full bg-accent px-4 py-[9px] text-sm font-medium text-white transition-colors hover:bg-accent-cta-hover min-[620px]:inline-flex"
          >
            Free trial
          </a>
        </div>
      </nav>
    </header>
  );
}
